import '../App.css'
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import { useState } from 'react';

import Header from "../components/Layout/Header";
import LogoutButton from "../components/Layout/LogoutButton";
import AuthStep from "../components/Steps/AuthStep";
import { login as loginApi } from '../api/api';
import SidebarMenu from '../components/Layout/SidebarMenu';
import AdminCompetitions from '../pages/admin/AdminCompetitions';
import CompetitionDetail from '../pages/admin/CompetitionDetail';
import AdminDashboard from '../pages/admin/AdminDashboard';
import CreateCompetitionForm from '../pages/admin/CreateCompetitionForm';
import CompetitionEvent from '../pages/admin/CompetitionEvent';
import { useAuth } from '../context/AuthContext'
import { useAlert } from '../context/AlertContext';
import CreateCompetitionEventForm from '../pages/admin/CreateCompetitionEventForm';
import AdminLayout from '../components/Layout/AdminLayout';
import CreateTeam from '../pages/admin/CreateTeam';
import { StepProvider } from '../context/StepContext';
import CreateTeamMembers from '../pages/admin/CreateTeamMembers';
import RepCompetitionTeams from '../pages/admin/RepCompetitionTeams';
import SyncRepData from '../pages/admin/SyncRepData';

function AdminContent() {
  const { user, loginAdmin, logout } = useAuth();
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const [step, setStep] = useState(user ? 0 : -1);

  const handleLogin = async (lastName, userBadgeId) => {
    try {
      const res = await loginApi({ lastName: 'admin', userBadgeId, role: 'admin' });
      if (res.status === 200) {
        const expires = new Date();
        expires.setDate(expires.getDate() + 7);
        loginAdmin(lastName, userBadgeId, { path: '/', expires });
        navigate('/admin/competitions');
      } else {
        showAlert(['Invalid admin credentials.'], 'error');
      }
    } catch (error) {
      showAlert(['Login failed. Please check your credentials.'], 'error');
    }
  };

  return (
    <div className="bg-pink-100 flex flex-col justify-center items-center sm:justify-start text-black min-h-screen max-h-min">
      <Routes>
        <Route
          path="/login"
          element={
            !user || user.role !== 'admin' ? (
              <div className='w-full sm:w-6/12'>
                <Header adminPortal={true} logout={logout} user={user}/>
                <AuthStep adminPortal={true} onLogin={handleLogin} />
              </div>
            ) : <Navigate to="/admin/competitions" replace />
          }
        />

        <Route
          path="/dashboard"
          element={
            user ? (
              <div className="flex w-full max-w-screen h-screen min-h-screen">
                <SidebarMenu setStep={setStep} step={step}/>
                <div className='flex-1'>
                  <Header adminPortal={true} logout={logout} user={user} />
                  <LogoutButton onLogout={logout} />
                  <AdminDashboard step={step} setStep={setStep} />
                </div>
              </div>
            ) : (
              <Navigate to="/admin/login" replace />
            )
          }
        />

        {/* Protected admin routes */}
        {user && (
          <Route element={<AdminLayout/>}>
            <Route
              path="/competitions"
              element={
                <div className="flex justify-center items-center w-screen max-w-screen h-screen min-h-screen">
                  <AdminCompetitions step={step} setStep={setStep} />
                </div>
              }
            />
            <Route
              path="/sync_rep_data"
              element={
                <div className="flex justify-center items-center w-screen max-w-screen h-screen min-h-screen">
                  <SyncRepData />
                </div>
              }
            />
            <Route
              path="/rep_teams"
              element={
                <div className="flex justify-center items-center w-screen max-w-screen h-screen min-h-screen">
                  <RepCompetitionTeams />
                </div>
              }
            />
            <Route
              path="/competitions/:id"
              element={
                <div className="flex justify-center items-center w-screen max-w-screen h-screen min-h-screen">
                  <CompetitionDetail />
                </div>
              }
            />
            <Route
              path="/competitions/:id/competition_events/editing/:editing/:event_id"
              element={<CreateCompetitionEventForm />}
            />
            <Route
              path="/competitions/editing/:editing/:id"
              element={
                <div className="flex justify-center items-center w-screen max-w-screen h-screen min-h-screen">
                  <CreateCompetitionForm />
                </div>
              }
            />
            <Route
              path="/competition_events/:id"
              element={
                <div className="flex justify-center items-center w-screen max-w-screen h-screen min-h-screen">
                  <CompetitionEvent />
                </div>
              }
            />
          </Route>
        )}

        {/* Public routes that aren't protected */}
        <Route
          path="/competitions/:competition_id/competition_events/:competition_event_id/competition_team/:editingTeam/:team_id"
          element={
            <div className="flex justify-center items-center w-screen max-w-screen h-screen min-h-screen">
              <CreateTeam />
            </div>
          }
        />
        <Route
          path="/competitions/:competition_id/competition_events/:competition_event_id/competition_teams/:competition_team_id/editing/:editing"
          element={
            <div className="flex justify-center items-center w-screen max-w-screen h-screen min-h-screen">
              <CreateTeamMembers />
            </div>
          }
        />

        {/* Catch-all redirect for unauthenticated access */}
        {!user && (
          <Route path="*" element={<Navigate to="/admin/login" replace />} />
        )}
      </Routes>
    </div>
  );
}

export default function AdminApp() {
  return (
    <StepProvider>
      <AdminContent />
    </StepProvider>
  );
}
